export default "__VITE_ASSET__DAELaWJo__"